import { FC } from "react";

import dynamic from "next/dynamic";

import { getCanvassingDataQuery } from "lib/sanity/queries";
import { getClient } from "lib/sanity/server";

import { RankedTableDataProps } from "components/ranked-table/types";
import ExploreMoreIntegrations from "components/views/integrations/explore-integrations";
import FeatureTable from "components/views/integrations/feature-table";
import { integrationDescriptions } from "components/views/integrations/integration-descriptions";
import PartnerWithEnerflo from "components/views/integrations/partner-with-enerflo";

import Page from "../../components/layout/page";
import MainHero from "../../components/views/integrations/sales-qualification/main-hero";

const Features = dynamic(() => import("../../components/views/integrations/canvassing-apps"));
const DemoFormSection = dynamic(() => import("../../components/demo-form-section"));

const SalesQualification: FC<RankedTableDataProps> = props => (
  <Page
    title="Integrations for Solar Sales Qualification"
    description="Enerflo integrates with sales qualification tools and software, including SalesRabbit, Spotio, Canvass Master, Nomo, Rep Card and more."
  >
    <MainHero />
    <FeatureTable title="Better Together: Level Up Your Sales Game with Integrated Canvassing & Qualification Apps">
      <Features {...props} />
      <p className="mt-2 text-center text-xs text-gray-400">
        <strong className="font-bold uppercase">Please Note:</strong> ”Custom” indicates that additional development /
        configuration work is required to enable the feature within the 3rd party tool.
      </p>
    </FeatureTable>
    <ExploreMoreIntegrations
      items={[integrationDescriptions.design, integrationDescriptions.finance, integrationDescriptions.overview]}
    />
    <PartnerWithEnerflo />
    <DemoFormSection />
  </Page>
);

export default SalesQualification;

export async function getStaticProps(ctx) {
  const { preview = null } = ctx;

  const client = getClient(preview);
  let canvassingData: RankedTableDataProps = {
    integratorsList: [],
    features: [],
  };

  try {
    canvassingData = await client.fetch(getCanvassingDataQuery(preview));
  } catch (e) {
    console.error("Unable to fetch canvassing data", e);
  }

  return {
    props: {
      preview,
      ...canvassingData,
    },
  };
}
